import { useDispatch, useSelector } from 'react-redux'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import { getStartATabModal } from '../../Selectors'
import { setStartATabModal } from '../../ActionCreators'
import { useEffect, useRef } from 'react'

/**
 * Modal for entering a name when starting a new tab
 */
export const VNStartATabModal = () => {
  const props = useSelector(getStartATabModal)
  const dispatch = useDispatch()
  const tabNameInputRef = useRef()

  useEffect(() => {
    if (props?.open) {
      setTimeout(() => {
        tabNameInputRef?.current?.focus()
        tabNameInputRef?.current?.select()
      }, 100)
    }
  }, [props])

  if (!props?.open) {
    return null
  }

  return (
    <ConfirmModalV2
      headerText={'Tab Name'}
      buttonTwoText={'SAVE'}
      initialInputValue={props?.initialInputValue}
      singleButtonOnly
      onButtonTwoClick={(name) => {
        props?.onSaveClick?.(name)
        dispatch(setStartATabModal({ open: false }))
      }}
      inputRef={tabNameInputRef}
      useInput={true}
    />
  )
}
